// 部门树实体类
export interface DeptInterface {
  // 部门名称
  title?: string;
  // 部门id
  key?: string;
  value?: string;
  icon?: string;
  // 是否被选中
  selected?: boolean;
  // 是否展开(叶子节点无效)
  expanded?: boolean;
  children?: Array<DeptInterface>;
}

// 人员实体类
export interface BaseUserInterface {
  checked?: boolean; // 是否选中
  disabled?: boolean; // 是否禁用
  // 用户id
  userId?: string;
  account?: string;
  password?: string;
  // 用户名
  realName?: string;
  // 用户名后两字
  header?: string;
  userType?: number;
  // 学工号
  userCode?: string;
  sex?: number;
  email?: string;
  mobile?: string;
  officePhone?: string;
  readNumber?: string;
  status?: number;
  displayIndex?: number;
  idCard?: string;
  lastDate?: Date;
  operUser?: string;
  twoPassword?: string;
  lastLoginTime?: Date;
  remark?: string;
  errorCount?: number;
  question?: string;
  answer?: string;
  theme?: string;
  roles?: Array<any>;
  roleIdList?: string;
  rolesData: string;
  dept?: BaseUserDept;
  deptId?: string;
  isDelete?: number;
  avatarId?: string;
  bgimgId?: string;
  profile?: string;
  passwordStrength?: string;
  lastLoginIp?: string;
}

export interface BaseUserDept {
  deptId?: string;
  // 部门名称
  deptName?: string;
  deptType?: string;
  deptComment?: string;
  leaf?: number;
  displayIndex?: number;
  deptCode?: string;
  status?: number;
  children?: Array<any>;
  pid?: string;
  expand?: boolean;
  createdDate?: Date;
}

// 组件参数
export class ComponentOption {
  includeClass?: boolean = true; // 是否包含班级(普通部门+系部+班级)，true:普通部门+系部+班级，false:普通部门+系部，默认为true
  includeHisClass?: boolean = true; // 是否包含历史班级，默认为true,只在includeClass=true时起作用
  count?: number = 0; // 最多人数限制，默认不限制
  defaultContacts?: Array<any> = []; // 默认已被选择的人员
  onlyStudent?: boolean = false; // 部门树只选学生（系部+班级）
  userTypes?: string = null; // 人员类型，多个类型以逗号隔开。当按部门查询且只选学生(onlyStudent = true)时默认为“2,3”,更改不起作用,其他情况下无默认值可做修改；
}
